/** The Supperkeep mark: an enamel sugar canister (navy rims, pistachio label, butter knob). */
export function BrandMark({ className = "brand__mark" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <rect width="64" height="64" rx="16" style={{ fill: "var(--color-primary)" }} />
      <rect x="17" y="24" width="30" height="30" rx="6" style={{ fill: "var(--color-enamel)" }} />
      <rect x="17" y="34" width="30" height="9" style={{ fill: "var(--color-pistachio)" }} />
      <rect x="14" y="17" width="36" height="9" rx="4.5" style={{ fill: "var(--color-enamel)", stroke: "var(--color-primary)", strokeWidth: 2 }} />
      <circle cx="32" cy="13.5" r="4" style={{ fill: "var(--color-butter)" }} />
    </svg>
  );
}
